export const DOMAIN = "https://elearning0706.cybersoft.edu.vn";
export const TOKEN = "accessToken";
export const USER_LOGIN = "USER_LOGIN";
